webpackJsonp([4],{

/***/ "./components/Iframe/IframeComp.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("../node_modules/react-redux/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_scss__ = __webpack_require__("./components/Iframe/style.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__("../node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__("../node_modules/react-bootstrap/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_routes__ = __webpack_require__("./constants/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_routes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__constants_routes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_app__ = __webpack_require__("./constants/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_app__ = __webpack_require__("./actions/app.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_alert__ = __webpack_require__("./actions/alert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_analytics__ = __webpack_require__("./actions/analytics.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__("../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_alert__ = __webpack_require__("./constants/alert.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Alert_style_scss__ = __webpack_require__("./components/Alert/style.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Alert_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Alert_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helpers__ = __webpack_require__("./utils/helpers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_CustomHelmet__ = __webpack_require__("./components/utils/CustomHelmet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_user__ = __webpack_require__("./constants/user.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    color: ', ';\t\n'], ['\n    color: ', ';\t\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    color: ', '; \n'], ['\n    color: ', '; \n']);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





















var StyledCompTitle = __WEBPACK_IMPORTED_MODULE_9_styled_components__["b" /* default */].h1(_templateObject, function (props) {
  return props.theme.headlineColor;
});

var StyledTitleIcon = __WEBPACK_IMPORTED_MODULE_9_styled_components__["b" /* default */].span(_templateObject2, function (props) {
  return props.theme.headlineColor;
});

var IframeComp = function (_React$Component) {
  _inherits(IframeComp, _React$Component);

  function IframeComp(props) {
    _classCallCheck(this, IframeComp);

    var _this = _possibleConstructorReturn(this, (IframeComp.__proto__ || Object.getPrototypeOf(IframeComp)).call(this, props));

    _this.state = {
      changes: false
    };
    _this.execute = _this.execute.bind(_this);
    _this.setIframeRef = _this.setIframeRef.bind(_this);
    _this.iframeFuncs = {
      startCharger: function startCharger() {
        _this.props.chargerActions.setFetchingCount(true);
      },
      closeCharger: function closeCharger() {
        _this.showIframe();
        _this.props.chargerActions.closeCharger();
      },
      setChange: function setChange(changes) {
        _this.setState({ changes: changes });
      },
      reportAndNavigate: _this.reportAndNavigate.bind(_this),
      report: _this.report.bind(_this),
      setIframeHeight: _this.setIframeHeight.bind(_this),
      customAlert: _this.customAlert.bind(_this)
    };
    //
    _this.initByPathFuncs = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__constants_routes__["ACTION_PATH_PARAMS"], _this.initActionItemPathParams.bind(_this));
    return _this;
  }

  _createClass(IframeComp, [{
    key: 'initActionItemPathParams',
    value: function initActionItemPathParams() {
      var queryString = window.location.search;
      if (queryString.length > 0) {
        queryString = queryString.replace('?', '&');
      }
      var id = this.props.match.params.id;
      var status = id.split(':')[3] || -1;
      if ([__WEBPACK_IMPORTED_MODULE_7__constants_app__["a" /* default */].STATUS_DISABLED, __WEBPACK_IMPORTED_MODULE_7__constants_app__["a" /* default */].STATUS_COMPLETED].indexOf(status) >= 0) {
        this.setState({ changes: false });
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.chargerActions.setFetchingCount(true);
      if (this.initByPathFuncs[this.props.match.path]) {
        this.initByPathFuncs[this.props.match.path]();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.resizeEvent = this.setIframeHeight.bind(this);
      this.checkIframeLoaded();
    }
  }, {
    key: 'shouldBlockNavigation',
    value: function shouldBlockNavigation() {
      // apply discard prompt only on the pages in this array.
      return [__WEBPACK_IMPORTED_MODULE_6__constants_routes__["INCIDENT_PATH"], __WEBPACK_IMPORTED_MODULE_6__constants_routes__["SR_PATH"], __WEBPACK_IMPORTED_MODULE_6__constants_routes__["ACTION_PATH_PARAMS"]].indexOf(this.props.match.path) !== -1 && this.state.changes;
    }
  }, {
    key: 'navigateWithoutPrompt',
    value: function navigateWithoutPrompt() {
      var _this2 = this;

      this.setState({ changes: false }, function () {
        return _this2.props.history.push(__WEBPACK_IMPORTED_MODULE_6__constants_routes__["ROOT_PATH"]);
      });
    }
  }, {
    key: 'reportAndNavigate',
    value: function reportAndNavigate(data) {
      this.report(data);
      this.navigateWithoutPrompt();
      this.props.chargerActions.closeCharger();
    }
  }, {
    key: 'report',
    value: function report(data) {
      this.props.analyticActions.reportAnalytics([data.category, data.action]);
    }
  }, {
    key: 'initAlertFromChild',
    value: function initAlertFromChild() {
      this.props.alertActions.toggleAlert(false);

      // let alertType  = document.getElementById('actionValue').value;
      var alertType = this.refs.actionValue.value;
      var responseObject = void 0;

      // if (document.getElementById('responseObjectValue').value.length) {
      if (this.refs.responseObjectValue.value.length) {
        responseObject = JSON.parse(this.refs.responseObjectValue.value);
      }

      var alertIcon = void 0;
      var alertTitle = void 0;
      var alertText = void 0;
      var alertStyle = void 0;
      var errorIcon = 'errorIcon';
      var successIcon = 'successIcon';
      var displayTime = void 0;
      var closeButton = void 0;

      var dueDateText = void 0;
      var assignedToText = void 0;

      switch (alertType) {
        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].MANDATORY_FIELDS_ERR:
          alertIcon = errorIcon;
          alertTitle = this.props.intlObject['ssp.alert.mandatory.fields.title'];
          alertText = this.props.intlObject['ssp.alert.mandatory.fields.text'];
          alertStyle = 'danger';
          displayTime = 3000;
          break;

        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].FORM_SUBMIT_SUCCESS:
          if (responseObject.due_date) {
            dueDateText = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              this.props.intlObject['ssp.alert.form.submit.success.due.by'],
              ' ',
              responseObject.due_date,
              '.'
            );
          }
          if (responseObject.assigned_to) {
            assignedToText = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              this.props.intlObject['ssp.alert.form.submit.success.assigned.to'],
              ' ',
              responseObject.assigned_to,
              '.'
            );
          }

          alertIcon = successIcon;
          alertTitle = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            this.props.intlObject['ssp.alert.form.submit.success.1.a'] + ' ',
            this.props.intlObject['ssp.alert.form.submit.' + responseObject.type] + ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],
              { to: '/SRview/' + responseObject.id,
                className: __WEBPACK_IMPORTED_MODULE_15__Alert_style_scss___default.a.alertLink },
              '' + this.props.intlObject['ssp.idPrefix'] + responseObject.id
            ),
            '. ',
            this.props.intlObject['ssp.alert.form.submit.success.1.b']
          );
          alertText = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            dueDateText,
            assignedToText
          );
          alertStyle = 'success';
          displayTime = 10000;
          closeButton = true;
          break;
        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].WORKFLOW_SUBMIT_SUCCESS:
          alertIcon = successIcon;
          alertTitle = this.props.intlObject['ssp.alert.workflow.update.success'] + ' ' + this.props.intlObject['ssp.idPrefix'] + responseObject.id;
          alertText = '';
          alertStyle = 'success';
          displayTime = 10000;
          closeButton = true;
          break;
        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].WORKFLOW_UPDATE_FAILED:
          alertIcon = errorIcon;
          alertTitle = this.props.intlObject['ssp.alert.workflow.update.failed.1'] + ' ' + this.props.intlObject['ssp.idPrefix'] + responseObject.id + ' ' + this.props.intlObject['ssp.alert.workflow.update.failed.2'];
          alertText = '';
          alertStyle = 'danger';
          displayTime = 10000;
          closeButton = true;
          break;
        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].INVALID_ID:
          alertIcon = errorIcon;
          alertTitle = this.props.intlObject['ssp.alert.form.submit.failure.invalidid'] + ' ' + responseObject.id;
          alertText = '';
          alertStyle = 'danger';
          displayTime = 3000;
          break;
        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].NO_PERMISSION:
          alertIcon = errorIcon;
          alertTitle = this.props.intlObject['ssp.alert.form.submit.failure.nopermission'];
          alertText = '';
          alertStyle = 'danger';
          displayTime = 3000;
          break;
        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].POPULATE_ERROR:
          alertIcon = errorIcon;
          alertTitle = this.props.intlObject['ssp.alert.form.submit.failure.populateError'];
          alertText = '';
          alertStyle = 'danger';
          displayTime = 3000;
          break;
        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].SUBMIT_ERROR:
          alertIcon = errorIcon;
          alertTitle = this.props.intlObject['ssp.alert.form.submit.error'];
          alertText = '';
          alertStyle = 'danger';
          displayTime = 3000;
          break;
        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].STORAGE_MANAGEMENT_APPLY:
          alertIcon = errorIcon;
          alertTitle = '' + this.props.intlObject['ssp.alert.form.apply.storage.management.title'];
          alertText = this.props.intlObject['ssp.alert.form.submit.storage.management.text'];
          alertStyle = 'warning';
          displayTime = 10000;
          closeButton = true;
          break;
        case __WEBPACK_IMPORTED_MODULE_14__constants_alert__["a" /* default */].STORAGE_MANAGEMENT:
          alertIcon = errorIcon;
          alertTitle = this.props.intlObject['ssp.alert.form.submit.storage.management.title'] + ' ' + responseObject.type + ' ' + this.props.intlObject['ssp.idPrefix'] + responseObject.id;
          alertText = this.props.intlObject['ssp.alert.form.submit.storage.management.text'];
          alertStyle = 'warning';
          displayTime = 10000;
          closeButton = true;
          break;
      }
      var alertData = { alertIcon: alertIcon, alertTitle: alertTitle, alertText: alertText, alertStyle: alertStyle, displayTime: displayTime, closeButton: closeButton };

      this.props.alertActions.initAlert(alertData);
    }
  }, {
    key: 'render',
    value: function render() {
      var _iframeSrcByRoute = this.iframeSrcByRoute(),
          iframeSrc = _iframeSrcByRoute.iframeSrc,
          compTitle = _iframeSrcByRoute.compTitle,
          pageTitle = _iframeSrcByRoute.pageTitle;

      var isBlockNavigation = this.shouldBlockNavigation();
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17__utils_CustomHelmet__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'title',
            null,
            pageTitle + ' - ' + this.props.intlObject['ssp.page.title']
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button', { onClick: this.execute, style: { display: 'none' }, id: 'executeBtn' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'hidden', id: 'actionValue', value: '', ref: 'actionValue' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'hidden', id: 'responseObjectValue', value: '', ref: 'responseObjectValue' }),
        compTitle,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('iframe', { id: 'formFrame',
          key: iframeSrc,
          src: iframeSrc,
          style: { visibility: 'hidden' },
          className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.iframe,
          scrolling: 'yes',
          allowFullScreen: true,
          title: pageTitle,
          ref: this.setIframeRef }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Prompt"], { when: isBlockNavigation, message: this.props.intlObject['ssp.discardChanges'] })
      );
    }
  }, {
    key: 'setIframeRef',
    value: function setIframeRef(iframe) {
      if (iframe) {
        this._iframe = iframe;
        this._innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      if (this.props.match.url !== next.match.url) {
        this.hideIframe();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.checkIframeLoaded();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeEvent);
      if (typeof document.getElementById('formFrame').contentWindow.removeComboClickEvent === 'function') {
        document.getElementById('formFrame').contentWindow.removeComboClickEvent();
      }
      this.props.chargerActions.closeCharger();
    }

    /* assigning the iframe src by router path */

  }, {
    key: 'iframeSrcByRoute',
    value: function iframeSrcByRoute() {
      // let path = this.props.pathName;
      var path = this.props.match.path;
      var queryString = window.location.search;
      if (queryString.length > 0) {
        queryString = queryString.replace('?', '&');
      }
      var id = this.props.match.params.id;
      var iframeSrc = void 0;
      var compTitle = void 0;
      var titleIcon = void 0;
      var titleText = void 0;
      var _ref = [],
          actionId = _ref[0],
          pageId = _ref[1],
          subPageId = _ref[2];

      var pageTitle = void 0;

      switch (path) {
        case __WEBPACK_IMPORTED_MODULE_6__constants_routes__["ACTION_PATH_PARAMS"]:
          var _id$split = id.split(':');

          var _id$split2 = _slicedToArray(_id$split, 3);

          actionId = _id$split2[0];
          pageId = _id$split2[1];
          subPageId = _id$split2[2];

          iframeSrc = '/ActionItemEditSelfServicePortal.jsp?id=' + actionId + '&pageID=' + pageId + '&subPageID=' + subPageId + queryString;
          titleIcon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledTitleIcon, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('iconIssue', 'editIcon', __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.titleIcon) });
          titleText = this.props.intlObject['ssp.iframe.title.action.edit'];
          pageTitle = this.props.intlObject['ssp.page.title.action.edit'] + ' ' + this.props.intlObject['ssp.idPrefix'] + actionId;
          break;
        case __WEBPACK_IMPORTED_MODULE_6__constants_routes__["SR_PATH"]:
          iframeSrc = '/SubmitSRSelfServicePortal.jsp?srType=request&resetBeans=true' + queryString;
          titleIcon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledTitleIcon, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('iconIssue', 'requestTitleIcon', __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.titleIcon) });
          titleText = this.props.intlObject['ssp.iframe.title.submit.sr'];
          pageTitle = this.props.intlObject['ssp.page.title.submit.request'];
          break;
        case __WEBPACK_IMPORTED_MODULE_6__constants_routes__["INCIDENT_PATH"]:
          iframeSrc = '/SubmitSRSelfServicePortal.jsp?resetBeans=true' + queryString;
          // titleIcon = <img src={incidentIcon}  alt="Submit Incident"/>;
          titleIcon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledTitleIcon, { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('iconIssue', 'incidentTitleIcon', __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.titleIcon) });
          titleText = this.props.intlObject['ssp.iframe.title.submit.incident'];
          pageTitle = this.props.intlObject['ssp.page.title.submit.incident'];
          break;
        default:
          iframeSrc = '';
          titleIcon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["k" /* Glyphicon */], { glyph: 'remove' });
          titleText = 'Nothing here, shoo!';
      }
      compTitle = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { 'aria-label': titleText, tabIndex: '0', id: 'titleWrapperDiv', className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.titleWrapper },
        titleIcon,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          StyledCompTitle,
          { className: __WEBPACK_IMPORTED_MODULE_3__style_scss___default.a.compTitle },
          titleText
        )
      );
      return { iframeSrc: iframeSrc, compTitle: compTitle, pageTitle: pageTitle };
    }
  }, {
    key: 'hideIframe',
    value: function hideIframe() {
      this._iframe.style.visibility = 'hidden';
    }
  }, {
    key: 'showIframe',
    value: function showIframe() {
      this._iframe.style.visibility = 'visible';
    }
  }, {
    key: 'addResizeEvent',
    value: function addResizeEvent() {
      window.addEventListener('resize', this.resizeEvent);
    }
  }, {
    key: 'injectCss',
    value: function injectCss() {
      var doc = this._iframe.contentDocument || this._iframe.contentWindow.document;
      this._iframe.addEventListener('load', iframeLoadedCallback);
      var self = this;

      function iframeLoadedCallback() {
        if (doc !== self._iframe.contentDocument && doc !== self._iframe.contentWindow.document) {
          doc = self._iframe.contentDocument || doc !== self._iframe.contentWindow.document;
        }

        self.setIframeHeight();

        setTimeout(function () {
          self.showIframe();
          self.props.chargerActions.closeCharger();
        }, 0);

        self._iframe.removeEventListener('load', iframeLoadedCallback);
        self.addResizeEvent();
      }
    }
  }, {
    key: 'injectTheme',
    value: function injectTheme() {
      localStorage.theme = JSON.stringify(this.props.theme);
      localStorage.dateTimeFormat = Object(__WEBPACK_IMPORTED_MODULE_16__utils_helpers__["i" /* getFullDateTimeFormatByCulture */])(this.props.dateFormat);
    }
  }, {
    key: 'setIframeHeight',
    value: function setIframeHeight() {

      var iframeElm = this._iframe,
          iframeRoot = iframeElm.contentDocument,
          iframeDocument = iframeRoot.documentElement,
          iframeInnerElm = iframeRoot.querySelector('#sspContent') || iframeRoot.querySelector('body'),
          iframeHeight = void 0;

      // Adjust height based on content height
      iframeHeight = Math.max(iframeInnerElm.scrollHeight, iframeInnerElm.offsetHeight);
      // Minimum of 200 is required
      iframeHeight = iframeHeight > 200 ? iframeHeight : 200;
      // Adjust height in CSS (must end with a unit)
      iframeElm.style.height = iframeHeight + 'px';

      // Re-adjust based on Document height (extra spacing issue)
      iframeHeight = Math.max(iframeDocument.scrollHeight, iframeDocument.offsetHeight);
      iframeElm.style.height = iframeHeight + 'px';
    }

    // This function ONLY works for iFrames of the same origin as their parent
    // see: http://stackoverflow.com/a/24621957/1723752
    // and http://stackoverflow.com/questions/24603580/how-can-i-access-the-dom-elements-within-an-iframe/24603642#comment38157462_24603642

  }, {
    key: 'iFrameReady',
    value: function iFrameReady(iFrame, fn) {
      var timer;
      var fired = false;

      function ready() {
        if (!fired) {
          fired = true;
          clearTimeout(timer);
          fn.call(this);
        }
      }

      function readyState() {
        if (this.readyState === 'complete') {
          ready.call(this);
        }
      }

      // cross platform event handler for compatibility with older IE versions
      function addEvent(elem, event, fn) {
        if (elem.addEventListener) {
          return elem.addEventListener(event, fn);
        } else {
          return elem.attachEvent('on' + event, function () {
            return fn.call(elem, window.event);
          });
        }
      }

      // use iFrame load as a backup - though the other events should occur first
      // addEvent(iFrame, 'load', function () {
      // 	ready.call(iFrame.contentDocument || iFrame.contentWindow.document);
      // });

      function checkLoaded() {
        var doc = iFrame.contentDocument || iFrame.contentWindow && iFrame.contentWindow.document;
        // We can tell if there is a dummy document installed because the dummy document
        // will have an URL that starts with 'about:'.  The real document will not have that URL
        if (doc && doc.URL.indexOf('about:') !== 0) {
          if (doc.readyState === 'complete') {
            ready.call(doc);
          } else {
            // set event listener for DOMContentLoaded on the new document
            addEvent(doc, 'DOMContentLoaded', ready);
            addEvent(doc, 'readystatechange', readyState);
          }
        } else {
          // still same old original document, so keep looking for content or new document
          timer = setTimeout(checkLoaded, 1);
        }
      }
      checkLoaded();
    }
  }, {
    key: 'checkIframeLoaded',
    value: function checkIframeLoaded() {
      var _this3 = this;

      // Check if loading is complete
      if (this._innerDoc != undefined) {
        this.iFrameReady(this._iframe, function () {
          _this3.injectCss();
          _this3.injectTheme();
        });
      }
    }
  }, {
    key: 'execute',
    value: function execute(e) {
      var params = JSON.parse(e.target.getAttribute('data-params'));
      if (typeof this.iframeFuncs[params.action] === 'function') {
        this.iframeFuncs[params.action](params.data);
      }
    }
  }, {
    key: 'customAlert',
    value: function customAlert() {
      this.props.alertActions.toggleAlert(false);
      this.initAlertFromChild();
      this.props.alertActions.toggleAlert(true);
    }
  }]);

  return IframeComp;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

IframeComp.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  intlObject: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  theme: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  chargerActions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  alertActions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  dateFormat: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  analyticActions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};

function mapStateToProps(state) {
  return {
    theme: state.app.get(__WEBPACK_IMPORTED_MODULE_7__constants_app__["a" /* default */].THEME),
    dateFormat: state.user.getIn([__WEBPACK_IMPORTED_MODULE_18__constants_user__["a" /* default */].INPUT_DATE])
  };
}

function mapDispatchToProps(dispatch) {
  return {
    chargerActions: Object(__WEBPACK_IMPORTED_MODULE_13_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_10__actions_app__, dispatch),
    alertActions: Object(__WEBPACK_IMPORTED_MODULE_13_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_11__actions_alert__, dispatch),
    analyticActions: Object(__WEBPACK_IMPORTED_MODULE_13_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_12__actions_analytics__, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(IframeComp)));

/***/ }),

/***/ "./components/Iframe/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("../node_modules/react-redux/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Authorization__ = __webpack_require__("./containers/Authorization/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IframeComp__ = __webpack_require__("./components/Iframe/IframeComp.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_intl__ = __webpack_require__("./constants/intl.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Iframe = function (_React$Component) {
	_inherits(Iframe, _React$Component);

	function Iframe() {
		_classCallCheck(this, Iframe);

		return _possibleConstructorReturn(this, (Iframe.__proto__ || Object.getPrototypeOf(Iframe)).apply(this, arguments));
	}

	_createClass(Iframe, [{
		key: 'render',
		value: function render() {
			// TODO: refactor - use only one component for iframe.
			return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
				'div',
				null,
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__IframeComp__["a" /* default */], { intlObject: this.props.intlObject })
			);
		}
	}]);

	return Iframe;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Iframe.propTypes = {
	intlObject: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};

function mapStateToProps(state) {
	return {
		intlObject: state.intl.get(__WEBPACK_IMPORTED_MODULE_5__constants_intl__["a" /* default */].INTL_OBJECT)
	};
}

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__containers_Authorization__["a" /* default */])(Iframe)));

/***/ }),

/***/ "./components/Iframe/style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navbarWrapper":"style__navbarWrapper___riJ2L","navbar-inverse":"style__navbar-inverse___3s9fc","menuMobile":"style__menuMobile___2SlSl","nav":"style__nav___Hl3VU","noPointer":"style__noPointer___2fYrB","cropper-container":"style__cropper-container___1Nhho","navbar-brand":"style__navbar-brand___13X40","alertWrapper":"style__alertWrapper___h2VrQ","in":"style__in___25Ih7","alert":"style__alert___3ZUOZ","alert-danger":"style__alert-danger___3XYd-","alert-success":"style__alert-success___3MFwr","alert-warning":"style__alert-warning___Em8JC","toolbarButtons":"style__toolbarButtons___nLME-","btn-primary":"style__btn-primary___1i9CW","active":"style__active___3mo0w","panel-group":"style__panel-group___3mGYC","panel":"style__panel___SyuW_","panel-heading":"style__panel-heading___TO1Wa","panel-title":"style__panel-title___2Vi2A","mobileScoreboard":"style__mobileScoreboard___3NwG1","panel-body":"style__panel-body___3z8Mg","multiWidgetRow":"style__multiWidgetRow___1Vsbw","insertTime":"style__insertTime___2zl_h","workFlowColumn2":"style__workFlowColumn2___2x6g_","column2":"style__column2___12ljA","column1":"style__column1___1yRzK","defaultDetails":"style__defaultDetails___2azyM","export":"style__export___1VMJf","search":"style__search___2DToT","RTL":"style__RTL___nayrx","more_actions_content":"style__more_actions_content___9Cwpm","tabs_3":"style__tabs_3___bCwTS","nav-pills":"style__nav-pills___3K2nb","tabs_4":"style__tabs_4___2Hx3X","oneColumnDetails":"style__oneColumnDetails___2vRlO","tabTitle":"style__tabTitle___3egTK","scoreboardFilter":"style__scoreboardFilter___1bDMJ","container":"style__container___zrmSK","Select-option":"style__Select-option___38uur","Select-arrow-zone":"style__Select-arrow-zone___lDVYT","Select--multi":"style__Select--multi___vWB0t","Select-value-icon":"style__Select-value-icon___JY-Fs","Select-value-label":"style__Select-value-label___2rPQ1","singleSelect":"style__singleSelect___2aNrV","modal-body":"style__modal-body___LLcbI","Select-input":"style__Select-input___3QORk","modal-dialog":"style__modal-dialog___GY1FT","SRviewTabsWrapper":"style__SRviewTabsWrapper___GTmD6","tab-content":"style__tab-content___3vAt5","faqWidgetWrapper":"style__faqWidgetWrapper___3NxQw","extraDetails":"style__extraDetails___1IIwL","faqListItemsWrapper":"style__faqListItemsWrapper___2-TVP","eyeOpen":"style__eyeOpen___anfL2","thumbsUp":"style__thumbsUp___2rz3W","arrowRight":"style__arrowRight___mvZim","arrowLeft":"style__arrowLeft___1HhOE","addNoteIcon":"style__addNoteIcon___2MANl","closeTicket":"style__closeTicket___2HPyC","reOpenTicket":"style__reOpenTicket___2tesb","errorIcon":"style__errorIcon___3Frw0","successIcon":"style__successIcon____iOVU","arrowUpIcon":"style__arrowUpIcon___2hikN","arrowDownIcon":"style__arrowDownIcon___2Upav","iconIssueWhite":"style__iconIssueWhite___30DE-","iconRequestWhite":"style__iconRequestWhite___CyI01","iconRequest":"style__iconRequest___1fDFC","IssueIcon":"style__IssueIcon___1HVVC","requestTitleIcon":"style__requestTitleIcon___Eu7fr","incidentTitleIcon":"style__incidentTitleIcon___3STjZ","footerIcon":"style__footerIcon___3x8Pc","defaultIcon":"style__defaultIcon___1GJFQ","submitIncidentIcon":"style__submitIncidentIcon___3CLeO","submitRequestIcon":"style__submitRequestIcon___3Ldmt","scoreboardIcon":"style__scoreboardIcon___1wm3z","faqIcon":"style__faqIcon___26-uR","settingsIcon":"style__settingsIcon___2sDHz","passwordServicesIcon":"style__passwordServicesIcon___3Teyp","calendarIcon":"style__calendarIcon___1fNVC","myDesktopIcon":"style__myDesktopIcon___31FZ5","descriptionIcon":"style__descriptionIcon___2QW5W","solutionIcon":"style__solutionIcon___1am4s","ticketInfoIcon":"style__ticketInfoIcon___1E8l4","readMoreIcon":"style__readMoreIcon___36lVY","showLessIcon":"style__showLessIcon___JEPQc","blankIcon":"style__blankIcon___1pa4M","lockIcon":"style__lockIcon___1P0tc","searchIcon":"style__searchIcon___uRZoZ","optionHorizontalIcon":"style__optionHorizontalIcon___2iJ1w","srIcon":"style__srIcon___13uss","incidentTemplateIcon":"style__incidentTemplateIcon___LondZ","requestTemplateIcon":"style__requestTemplateIcon___18ffu","categoriesIncidentIcon":"style__categoriesIncidentIcon___2Kso8","categoriesRequestIcon":"style__categoriesRequestIcon___3QZ4H","playIcon":"style__playIcon___1Kojv","flagIcon":"style__flagIcon___3JyAq","mySettingsIcon":"style__mySettingsIcon___1JRDP","editIcon":"style__editIcon___l2M9H","deleteIcon":"style__deleteIcon___1UU01","chatIcon":"style__chatIcon___by7Cb","filterIcon":"style__filterIcon___20Zqi","toolbox_scoreboardIcon":"style__toolbox_scoreboardIcon___CKQRa","toolbox_cloudIcon":"style__toolbox_cloudIcon___1goA4","toolbox_faqIcon":"style__toolbox_faqIcon___29soF","toolbox_faq_itemIcon":"style__toolbox_faq_itemIcon___qYSlk","toolbox_linkIcon":"style__toolbox_linkIcon___BaPUg","toolbox_folderIcon":"style__toolbox_folderIcon___GwCfo","toolbox_category_infoIcon":"style__toolbox_category_infoIcon___13LqE","toolbox_category_pointerIcon":"style__toolbox_category_pointerIcon___2An00","toolbox_referenceIcon":"style__toolbox_referenceIcon___1btW5","toolbox_submitIncidentIcon":"style__toolbox_submitIncidentIcon___23Npa","toolbox_submit_incidentIcon":"style__toolbox_submit_incidentIcon___30B8_","toolbox_incident_template_linkIcon":"style__toolbox_incident_template_linkIcon___2Cv2Z","toolbox_submitRequestIcon":"style__toolbox_submitRequestIcon___pIIdg","toolbox_submit_requestIcon":"style__toolbox_submit_requestIcon___3LvoW","toolbox_request_template_linkIcon":"style__toolbox_request_template_linkIcon___3_kFc","toolbox_onlineIcon":"style__toolbox_onlineIcon___UBFCu","toolbox_passwordServicesIcon":"style__toolbox_passwordServicesIcon___19EVk","toolbox_settingsIcon":"style__toolbox_settingsIcon___3xnms","toolbox_chatIcon":"style__toolbox_chatIcon___6u2Fe","toolbox_calendarIcon":"style__toolbox_calendarIcon___3VMDw","toolbox_myDesktopIcon":"style__toolbox_myDesktopIcon___1S60U","filterFull":"style__filterFull___3aBjd","filterEmpty":"style__filterEmpty___2iwyy","actionItemIcon":"style__actionItemIcon___2L8E7","root":"style__root___2hR9i","iconIssue":"style__iconIssue___1_S6q","arrowRtSm":"style__arrowRtSm___27Mj6","topBottomMargin":"style__topBottomMargin___3UyxQ","topMargin":"style__topMargin___2PlOi","noSidePadding":"style__noSidePadding___2CteH","form-control":"style__form-control___17NGP","Select-option-group-label":"style__Select-option-group-label___1MJWX","Select-menu-outer":"style__Select-menu-outer___3UtRG","Select-control":"style__Select-control___6hgl1","titleWrapper":"style__titleWrapper___3NfXe","compTitle":"style__compTitle___cpGMl","titleIcon":"style__titleIcon___1_GKW","iframe":"style__iframe___yc7lT","setIframeHeightBtn":"style__setIframeHeightBtn___12-xd","navigateBtn":"style__navigateBtn___2-zIM","AlertBtn":"style__AlertBtn___3G7Rd"};

/***/ })

});


// WEBPACK FOOTER //
// iframeComp.bundle.c4ad148be759e338cea7.js